import React, { memo } from "react";
import { Breadcrumbs, Header, Workspace } from "components/Shared";
import { usePendingProjectsCount } from "v2/hooks";
import Collection from "./Collection";

const Projects = ({ history }: any) => {
	const pendingCount = usePendingProjectsCount();

	return (
		<React.Fragment>
			<Breadcrumbs items={[{ title: "projects" }]} />
			<Header
				title="projects"
				toolbar={[
					{ onClick: () => history.push("/projects/new"), label: "new_project", icon: "new" },
					{
						onClick: () => history.push("/projects/pending"),
						label: "pending_projects",
						icon: "pending_projects",
						badge: pendingCount > 0 && pendingCount,
						className: pendingCount > 0 ? "btn-attention" : "",
					},
				]}
			/>
			<Workspace id="projects" className="list">
				<Collection />
			</Workspace>
		</React.Fragment>
	);
};

const MemoizedProjects = memo(Projects);
export default ({ history }: any) => <MemoizedProjects history={history} />;
